/**
 * DEPRECATED AFTER MIGRATION FROM FLUX TO REDUX
 */ "use strict";
import keyMirror from "fbjs/lib/keyMirror";
export var ActionTypes = keyMirror({
    // View Events
    SELECT_TOPIC: null,
    SELECT_SEARCHED_TOPIC: null,
    SEARCH_TOPICS: null,
    SELECT_NOTE: null,
    // Server Events
    CONNECTION_UPDATE: null,
    RECEIVE_RAW_TOPICS: null,
    RECEIVE_RAW_TOPIC: null,
    RECEIVE_RAW_DESCRIPTION: null,
    RECEIVE_RAW_ACTIVITIES: null,
    RECEIVE_RAW_ACTIVITY: null,
    RECEIVE_RAW_FILE_UPLOAD_COMPLETE: null,
    RECEIVE_RAW_SPHERES: null,
    RECEIVE_RAW_SPHERE: null,
    RECEIVE_SESSION: null,
    RECEIVE_CONFIG: null,
    RECEIVE_ENDORSEMENT: null,
    RECEIVE_RAW_NOTES: null,
    RECEIVE_RAW_NOTE: null,
    RECEIVE_RATING: null,
    RECEIVE_PRINT_NOTES: null
});
export var PayloadSources = keyMirror({
    SERVER_ACTION: null,
    VIEW_ACTION: null
});
export default {
    ActionTypes: ActionTypes,
    PayloadSources: PayloadSources
};
